export const IMG_MARKER_GENERAL = "markerGeneral";
export const IMG_MARKER_FIELDWORKER_CAR = "markerFieldworkerCar";
export const IMG_MARKER_FIELDWORKER_MYWHEELS = "markerFieldworkerMyWheels";
export const IMG_MARKER_FIELDWORKER_BIKE = "markerFieldworkerBike";
export const IMG_MARKER_FIELDWORKER_PICK_UP = "markerFieldworkerPickUp";
export const IMG_MARKER_CIRCLE_DASHED_STROKE = "markerCircleDashedStroke";
export const IMG_MARKER_CHANGE_CIRCLE_OUTLINED = "markerChangeCircleOutlined";

export const MAP_STYLE_STANDARD = "Mapbox Standard";
export const MAP_STYLE_SATELLITE = "Mapbox Standard Satellite";

export const MAP_STYLES: Record<string, { label: string; styleUrl: string }> = {
    [MAP_STYLE_STANDARD]: {
        label: "Street",
        styleUrl: "mapbox://styles/mapbox/standard",
    },
    [MAP_STYLE_SATELLITE]: {
        label: "Satellite",
        styleUrl: "mapbox://styles/mapbox/standard-satellite",
    },
};

export const MAP_STYLE_CONFIG = {
    basemap: {
        theme: "faded",
        showPointOfInterestLabels: false,
    },
};
